import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const Stat = ({ label, value, tone = "", testid }) => (
  <div className="min-w-0" data-testid={testid}>
    <div className="text-[10px] uppercase tracking-wider text-muted-foreground font-semibold truncate">{label}</div>
    <div className={`text-sm font-semibold tabular-nums ${tone}`}>{value}</div>
  </div>
);

const semaforo = (pct, bueno, malo) => (pct == null ? "" : pct <= bueno ? "text-emerald-600" : pct >= malo ? "text-rose-600" : "text-amber-600");

export default function ComisionesVendedorCard({ v, fmt }) {
  const [open, setOpen] = useState(false);
  const pctSug = v.pct_del_sugerido;
  return (
    <div className="bg-card border border-border rounded-xl p-4" data-testid={`vendedor-card-${v.vendedor_id || "sin"}`}>
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-primary/10 text-primary font-bold flex items-center justify-center shrink-0">
          {(v.vendedor_nombre || "?").slice(0, 1).toUpperCase()}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-foreground truncate" data-testid="vendedor-nombre">{v.vendedor_nombre}</div>
          <div className="text-xs text-muted-foreground">{v.pedidos} pedidos · {v.clientes_unicos} clientes ({v.clientes_nuevos} nuevos) · ticket {fmt(v.ticket_promedio)}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="text-base font-bold tabular-nums text-foreground" data-testid="vendedor-ventas">{fmt(v.total_ventas)}</div>
          <div className="text-xs text-primary font-semibold tabular-nums">Comisión {fmt(v.total_comision)} · {v.comision_pct_efectiva}%</div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-2 mt-3 rounded-lg bg-muted/40 p-2">
        <Stat label="Por cobrar" value={fmt(v.comision_por_cobrar)} tone="text-emerald-600" />
        <Stat label="Bloqueada" value={fmt(v.comision_bloqueada)} tone="text-amber-600" />
        <Stat label="Liquidada" value={fmt(v.comision_liquidada)} tone="text-slate-500" />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mt-3">
        <Stat label="% del precio sugerido" value={pctSug == null ? "—" : `${pctSug}%`} tone={pctSug == null ? "" : pctSug >= 97 ? "text-emerald-600" : pctSug >= 90 ? "text-amber-600" : "text-rose-600"} testid="stat-pct-sugerido" />
        <Stat label="Ítems bajo mínimo" value={`${v.items_bajo_minimo} (${v.pct_items_bajo_minimo}%)`} tone={semaforo(v.pct_items_bajo_minimo, 2, 10)} testid="stat-bajo-minimo" />
        <Stat label="Cancelación" value={`${v.cancelados} (${v.tasa_cancelacion}%)`} tone={semaforo(v.tasa_cancelacion, 5, 20)} testid="stat-cancelacion" />
        <Stat label="Días prom. cobro" value={v.dias_promedio_pago == null ? "—" : `${v.dias_promedio_pago} d`} tone={semaforo(v.dias_promedio_pago, 7, 30)} testid="stat-dias-pago" />
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mt-2 text-[11px] text-muted-foreground">
        <span>Pagados {v.pedidos_pagados} · con saldo {v.pedidos_con_saldo} ({fmt(v.saldo_pendiente)})</span>
        <span>{v.unidades} unidades · descuentos {fmt(v.descuento_total)}</span>
      </div>

      <button onClick={() => setOpen(!open)} className="mt-3 text-xs font-semibold text-primary flex items-center gap-1" data-testid="vendedor-toggle-detalle">
        {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />} {open ? "Ocultar" : "Ver"} top productos y meses
      </button>
      {open && (
        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
          <div>
            <div className="font-semibold text-muted-foreground mb-1">Top productos</div>
            {(v.top_productos || []).map((p, i) => (
              <div key={i} className="flex justify-between gap-2 py-0.5 border-b border-border/60"><span className="truncate">{p.nombre || "—"}</span><span className="tabular-nums shrink-0">{p.unidades} u · {fmt(p.ventas)}</span></div>
            ))}
          </div>
          <div>
            <div className="font-semibold text-muted-foreground mb-1">Por mes</div>
            {(v.serie_mensual || []).slice(-12).map((m) => (
              <div key={m.mes} className="flex justify-between gap-2 py-0.5 border-b border-border/60"><span>{m.mes}</span><span className="tabular-nums">{m.pedidos} ped · {fmt(m.ventas)} · com {fmt(m.comision)}</span></div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
